import 'waypoints/lib/jquery.waypoints.min';
import 'waypoints/src/shortcuts/sticky';

if ( $( ".filter--wrap" ).length ) {
  new Waypoint.Sticky({
    element: $('.filter--wrap')[0]
  });
}